import React from 'react';
import { motion } from 'framer-motion';
import { bookInfo } from '../../data/bookData';
import { FiArrowRight } from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const editions = [
  { label: 'Kindle Edition', price: '$6.99', href: bookInfo.links.amazon.kindle, primary: true },
  { label: 'Paperback', price: '$17.99', href: bookInfo.links.amazon.paperback, primary: false },
  { label: 'Hardcover', price: '$26.99', href: bookInfo.links.amazon.hardcover, primary: false },
];

const ExcerptCta = () => (
  <section className="py-24 bg-brand-dark border-t border-white/5 relative overflow-hidden">
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-brand-accent/5 via-transparent to-transparent"></div>
    <div className="max-w-3xl mx-auto px-6 text-center relative z-10">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
      >
        <h2 className="text-3xl md:text-4xl font-display font-bold text-white mb-3">
          Get the Book on Amazon
        </h2>
        <p className="text-gray-400 mb-10 text-lg">
          Five centuries. Eight worlds. One signal that changes everything.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-10">
          {editions.map((ed) => (
            <a
              key={ed.label}
              href={ed.href}
              target="_blank"
              rel="noreferrer"
              className={`flex flex-col items-center justify-center gap-1 px-8 py-5 rounded-xl font-bold transition-all group ${
                ed.primary
                  ? 'bg-brand-accent text-brand-dark hover:bg-brand-accentHover'
                  : 'bg-white/5 text-white border border-white/15 hover:bg-white/10'
              }`}
            >
              <span className="text-base">{ed.label}</span>
              <span className={`text-sm font-normal ${ed.primary ? 'text-brand-dark/70' : 'text-gray-400'}`}>
                {ed.price}
              </span>
            </a>
          ))}
        </div>

        <a
          href={bookInfo.links.amazon.kindle}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-2 text-brand-accent hover:text-white transition-colors text-sm font-medium"
        >
          Get the Book on Amazon <SafeIcon icon={FiArrowRight} />
        </a>
      </motion.div>
    </div>
  </section>
);

export default ExcerptCta;